/**
 * 国际化 · 英文
 * ------------------------------------------------------------
 * 壳层固定文案的英文翻译，字段结构与 zhCN 完全对称。
 */
import type { Dict } from './zh-CN'

export const enUS: Dict = {
  nav: {
    chat: 'Chat',
    messenger: 'Groups',
    task: 'Tasks',
    sched: 'Calendar',
    files: 'Space',
    mine: 'Profile',
    cloudpc: 'Cloud PC',
    apps: 'Apps',
    arch: 'Architecture',
    appsShort: 'Apps',
    sol: 'R&D',
    fde: 'FDE',
    newChat: 'New Chat'
  },
  search: {
    placeholder: 'Search apps / codes / objects…',
    prefixHint: 'Type / to filter by type'
  },
  theme: {
    light: 'Light',
    dark: 'Dark',
    toggle: 'Toggle theme'
  },
  language: {
    zh: '中文',
    en: 'English'
  },
  common: {
    back: 'Back',
    home: 'Home',
    close: 'Close',
    confirm: 'OK',
    cancel: 'Cancel',
    loading: 'Loading…',
    empty: 'No data',
    more: 'Load more'
  },
  org: {
    title: 'Scope',
    scope: 'Access range',
    role: 'My role',
    perm: 'Execute perm',
    legal: 'Legal entity',
    period: 'Period',
    fresh: 'New org'
  },
  onb: {
    title: 'Welcome to EMA',
    step1Title: 'Review access',
    step1Desc: 'Confirm available apps and permissions',
    step2Title: 'Browse architecture',
    step2Desc: 'Get a quick view of connected domains and apps',
    step3Title: 'Connect business systems',
    step3Desc: 'Exceptions and tasks will appear after integration',
    start: 'Get started',
    arch: 'Browse architecture first'
  },
  footer: {
    shortcut: 'Enter to send · Shift+Enter for newline'
  }
}
